module.exports = __webpack_public_path__ + "img/8_l.e552c499.jpg";